export const pt = {
  upload: "Enviar",
  cancel: "Cancelar",
  close: "Fechar",
  uploading: "Enviando...",
  uploaded: "Enviado",
  fetching: "Buscando imagem de $1$...",
  poweredBy: "Fornecido por $1$",
  needHelp: "Precisa de ajuda?",

  units: {
    px: "px",
    "%": "%",
    deg: "°",
  },

  errors: {
    response_not_ok: "Ocorreu um erro ao buscar este arquivo",
    unable_to_search: "Não foi possível realizar a busca",
    invalid_service_url: "Esta URL não pertence a $1$",
    invalid_url: "Esta URL parece ser inválida",
    upload_aborted: "Seu envio foi cancelado",
    upload_error: "Ocorreu um erro durante o envio deste arquivo",
    file_type_not_allowed: "Este tipo de arquivo não é permitido",
    file_too_large: "Seu arquivo deve ser menor que $1$",
  },

  help: {
    loading: "Carregando ajuda...",
    close: "Fechar Ajuda",
  },

  services: {
    default: {
      heading: "Selecione uma imagem",
    },
    local: {
      title: "Escolher arquivo",
      button: "Selecione um arquivo",
      or: "ou",
      drop: "Arraste-os para cá",
    },
    camera: {
      title: "Câmera",
      button: "Tirar foto",
      switch: "Mudar câmera",
      waiting: "Esperando a permissão...",
      unableToRead:
        "Não foi possível obter acesso a câmera. Isto pode ter ocorrido se você não tiver permitido ou seu dispositivo suportar acesso a câmera.",
    },
    microlink: {
      button: "Importar $1$",
      label: "$2$ do $1$",
      placeholder: "Insira a URL do $2$ do $1$",
      type: "post",
    },
    url: {
      title: "URL",
      label: "URL da imagem",
      placeholder: "Insira a URL da imagem",
    },
    instagram: {
      title: "Instagram",
    },
    facebook: {
      title: "Facebook",
    },
    flickr: {
      title: "Flickr",
      type: "foto",
    },
    ninegag: {
      title: "9GAG",
      type: "foto",
    },
    deviantart: {
      title: "DeviantArt",
    },
    artstation: {
      title: "ArtStation",
    },
    twitter: {
      title: "Twitter",
      type: "tweet",
    },
    pinterest: {
      title: "Pinterest",
      type: "pin",
    },
    flipboard: {
      title: "Flipboard",
      type: "artigo",
    },
    fotki: {
      title: "Fotki",
      type: "foto",
    },
    linkedin: {
      title: "LinkedIn",
    },
    reddit: {
      title: "Reddit",
    },
    tumblr: {
      title: "Tumblr",
    },
    weheartit: {
      title: "We Heart It",
    },
    screenshot: {
      title: "Captura de tela (screenshot)",
      button: "Fazer captura da tela",
      label: "URL do site",
      placeholder: "Insira a URL do site",
      loading: "Fazendo captura...",
    },
    search: {
      button: "Pesquisar no $1$",
      label: "Procure uma imagem",
      placeholder: "Procurar algo",
      imagesPoweredBy: "Busca de imagens fornecida por $1$",
    },
    giphy: {
      title: "GIPHY",
    },
    unsplash: {
      title: "Unsplash",
    },
    pixabay: {
      title: "Pixabay",
    },
    pexels: {
      title: "Pexels",
    },
  },

  effects: {
    preview: {
      title: "Previsualização",
    },
    filters: {
      title: "Filtros",
    },
    crop: {
      title: "Corte",
      aspectRatios: {
        free: "Livre",
        square: "Quadrado",
      },
    },
    rotate: {
      title: "Rotacionar",
    },
    flip: {
      title: "Inverter",
      buttons: {
        horizontal: "Horizontal",
        vertical: "Vertical",
      },
    },
    sharpen: {
      title: "Aguçar",
    },
    blur: {
      title: "Desfocar",
    },
    brightness: {
      title: "Brilho",
    },
    contrast: {
      title: "Contraste",
    },
    grayscale: {
      title: "Escala de cinza",
    },
    "hue-rotate": {
      title: "Matiz",
    },
    invert: {
      title: "Inverter",
    },
    saturate: {
      title: "Saturar",
    },
    sepia: {
      title: "Sépia",
    },
  },
};
